import { mix } from "@chorda/core";
export const Progress = (props) => {
    return mix({
        tag: 'progress',
        css: 'progress'
    }, {
        css: props.css,
        dom: {
            value: props.value,
            max: props.max
        }
    });
};
